import { render, staticRenderFns } from "./AscTable.vue?vue&type=template&id=d49306f8&scoped=true&"
import script from "./AscTable.vue?vue&type=script&lang=js&"
export * from "./AscTable.vue?vue&type=script&lang=js&"
import style0 from "./AscTable.vue?vue&type=style&index=0&id=d49306f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49306f8",
  null
  
)

export default component.exports